import React, { memo, useCallback, useState } from 'react';
import { styled } from '@compiled/react';
import Popup from '@atlaskit/popup';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { popupWidth } from './constants.tsx';
import GroupByDropdownOptions from './dropdown-options/index.tsx';
import Trigger from './trigger/index.tsx';

const GroupByDropdown = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const close = useCallback(() => setIsOpen(false), []);
	const toggle = useCallback(() => setIsOpen((wasOpen) => !wasOpen), []);

	const content = useCallback(
		() => (
			<DropdownWrapper>
				<GroupByDropdownOptions popupWidth={popupWidth} onToggle={toggle} />
			</DropdownWrapper>
		),
		[toggle],
	);

	const trigger = useCallback(
		// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
		(triggerProps) => (
			<Trigger
				{...triggerProps}
				isSelected={isOpen}
				onClick={() => {
					fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'groupByDropdown');
					toggle();
				}}
			/>
		),
		[createAnalyticsEvent, isOpen, toggle],
	);

	return (
		<Popup
			isOpen={isOpen}
			onClose={close}
			placement="bottom-end"
			content={content}
			trigger={trigger}
		/>
	);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default memo<Record<any, any>>(GroupByDropdown);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DropdownWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: `${popupWidth}px`,
});
